'use strict';

const av = Autodesk.Viewing;
const namespace = AutodeskNamespace('Autodesk.AEC');
const myExtensionName = 'Autodesk.AEC.HyperlinkExtension';
import HyperlinkTracker from './HyperlinkTracker.js';

// Hyperlink extension which will display hyperlinks in 2D sheets to other sheets
//  @param {Number} options.rootBubbleNode Root bubble node of model
//  @callback options.loadViewableCb Will be called in case a hyperlink is clicked with bubble node of the sheet and
//      the total number of hyperlinks present in the sheet
//  @callback options.hyperlinksAddedCb Will be called each time hyperlinks have been added to a sheet with the id of
//      the model and the total number of hyperlinks present in the sheet
export default class HyperlinkExtension extends av.Extension {
    constructor(viewer, options) {
        super(viewer, options);

        this.hyperlinkTracker = new HyperlinkTracker(this.viewer, this.options.rootBubbleNode,
            this.options.loadViewableCb, this.options.hyperlinksAddedCb);
    }

    load() {
        this.viewer.toolController.activateTool('hyperlink-tracker');
        return true;
    }

    unload() {
        this.viewer.toolController.deactivateTool('hyperlink-tracker');
        return true;
    }
}

namespace.HyperlinkExtension = HyperlinkExtension;
Autodesk.Viewing.theExtensionManager.registerExtension(myExtensionName, HyperlinkExtension);
